const BACKEND_MODE = (process.env.REACT_APP_BACKEND_MODE || 'local').toLowerCase();
const isServerMode = BACKEND_MODE === 'server';

const LOCAL_STORE_ORIGIN = (
  process.env.REACT_APP_LOCAL_STORE_ORIGIN || 'http://127.0.0.1:9000/circle-moments-store'
).replace(/\/+$/, '');

const SERVER_STORE_ORIGIN = (process.env.REACT_APP_SERVER_STORE_ORIGIN || '').replace(/\/+$/, '');
const SERVER_STORE_PATH_PREFIX = (process.env.REACT_APP_SERVER_STORE_PATH_PREFIX || '/store').replace(/\/+$/, '');

const absoluteUrlPattern = /^[a-z][a-z\d+\-.]*:\/\//i;

export function resolveStoreAssetUrl(url) {
  if (!url || absoluteUrlPattern.test(url) || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }

  const storePath = url
    .replace(/^\/+store\/+/i, '')
    .replace(/^\/+/, '');

  if (isServerMode) {
    const serverPath = `${SERVER_STORE_PATH_PREFIX}/${storePath}`;
    return SERVER_STORE_ORIGIN ? `${SERVER_STORE_ORIGIN}${serverPath}` : serverPath;
  }

  return `${LOCAL_STORE_ORIGIN}/${storePath}`;
}
